import { useEffect, useState } from "react";
import { Box, Fade, Slide, Typography } from "@mui/material";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import WifiIcon from "@mui/icons-material/Wifi";

const barSx = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    px: 2,
    py: 1.25,
    boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
};

export default function NetworkStatusBar() {
    const [isOnline, setIsOnline] = useState(
        () => typeof navigator !== "undefined" && navigator.onLine
    );
    const [showRestored, setShowRestored] = useState(false);

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
            setShowRestored(true);
        };

        const handleOffline = () => {
            setIsOnline(false);
            setShowRestored(false);
        };

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);

    useEffect(() => {
        if (!showRestored) return undefined;
        const timer = setTimeout(() => setShowRestored(false), 3000);
        return () => clearTimeout(timer);
    }, [showRestored]);

    return (
        <>
            <Slide direction="down" in={!isOnline} mountOnEnter unmountOnExit>
                <Box
                    sx={{
                        ...barSx,
                        bgcolor: "#b71c1c",
                        color: "#fff",
                    }}
                    role="alert"
                    aria-live="assertive"
                >
                    <WifiOffIcon fontSize="small" aria-hidden />
                    <Typography variant="body2" fontWeight={600} sx={{ textAlign: "center" }}>
                        You are offline — changes will not be saved until your connection is restored
                    </Typography>
                </Box>
            </Slide>

            <Fade in={showRestored && isOnline} timeout={{ enter: 300, exit: 500 }} mountOnEnter unmountOnExit>
                <Box
                    sx={{
                        ...barSx,
                        bgcolor: "#1b5e20",
                        color: "#fff",
                    }}
                    role="status"
                    aria-live="polite"
                >
                    <WifiIcon fontSize="small" aria-hidden />
                    <Typography variant="body2" fontWeight={600}>
                        Connection restored
                    </Typography>
                </Box>
            </Fade>
        </>
    );
}
